<template>
  <div class="tw:bg-blue-200 tw:flex tw:w-full tw:py-[44px] tw:mt-2">
    <ContainerLayout>
      <div class="tw:order-1 tw:md:order-0 tw:w-full tw:md:w-[40%]" data-testid="hotel-offers-initial-banner">
        <h1 class="tw:text-[44px] tw:leading-[55px] tw:font-bold">{{ $t('hotel_offers_banner_header') }}</h1>
        <ul class="tw:mt-4 tw:flex tw:flex-col tw:gap-y-1">
          <li v-for="(tip, index) in tips" :key="index" class="tw:flex tw:gap-y-1 tw:gap-x-2">
            <CheckmarkSimple class="tw:text-gray-800 tw:stroke-gray-800 tw:size-6" />
            <span>{{ $t(tip) }}</span>
          </li>
        </ul>
        <MainButton @click="openCreateOfferOpen" class="tw:mt-6" dataTestId="setup-offer-ho-initial-banner-button">{{
          $t('hotel_offers_cta_post')
        }}</MainButton>
      </div>
      <div class="tw:order-0 tw:md:order-1 tw:w-full tw:md:w-[60%] tw:flex tw:items-center tw:justify-end">
        <img class="tw:w-full tw:max-h-[274px]" :src="hotelOffersBannerImage" :alt="$t('hotel_offers_banner_header')" />
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import MainButton from '@/components/base/buttons/MainButton.vue'
import CheckmarkSimple from '@/components/icons/CheckmarkSimple.svg?component'
import ContainerLayout from '@/layouts/ContainerLayout.vue'

import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const emit = defineEmits(['openCreateOfferOpen'])
const openCreateOfferOpen = () => {
  appAnalytics.track(appAnalytics.events.HO_POST_OFFER_INITIAL_BANNER_CLICKED, {
    accommodationId: selectedAccommodationId.value,
  })
  emit('openCreateOfferOpen', { offerName: null, source: 'banner' })
}

const hotelOffersBannerImage = new URL('/src/assets/img/hotel-offers/hotel-offers-banner.png', import.meta.url)
const tips = ['hotel_offers_benefit_1', 'hotel_offers_benefit_2', 'hotel_offers_benefit_3']
</script>
